import React, { useState } from "react";
import "./Add_offcanvas.css";
import Select from "react-select";
import { Button, Form, Offcanvas } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Blue_btn from "../../../../../../../common_components/common_btn/blue_btn/Blue_btn";
import Blue_border_button from "../../../../../../../common_components/common_btn/blue_border_button/Blue_border_button";
import Success_modal from "../../../../../../../common_components/common_modal/success_modal/Success_modal";
import successAnimation from "../../../../../../../animation/success_lottie/Success_lottie.json";
import classNames from "classnames";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import {
  Create,
  GetAll,
} from "../../../../../../../../features/admin/website/home/faq/slice";
import { IDS } from "../../../../../../../../utils/IDS";

function Add_offcanvas({
  setShow,
  setSuccess,
  setErr,
  setShowError,
  defaultValues,
  showError,
  show,
  handleClose,
  setShowRejectModal,
}) {
  const {
    register,
    handleSubmit,
    reset,
    watch,
    getValues,
    formState: { errors },
  } = useForm({ defaultValues });
  const dispatch = useDispatch();

  const [modalSuccessShow, setModalsuccessShow] = useState(false);

  // const onSubmit = async (data) => {
  //   try {
  //     const res = await dispatch(Create(data));
  //     if (res.meta?.requestStatus === "fulfilled") {
  //       dispatch(GetAll());
  //       setShow(false);
  //       setSuccess(true);
  //     } else if (res.meta?.requestStatus === "rejected") {
  //       console.log(
  //         res.payload?.response?.data?.errors,
  //         "res.payload?.response?.data?.errors"
  //       );

  //       setShowError(res.payload?.response?.data?.errors);
  //     }
  //   } catch (error) {
  //     setShow(false);
  //     setErr(true);
  //     console.error(error);
  //   }
  // };

  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();

      sendData.append("name", data?.name || "");
      sendData.append("description", data?.description || "");

      const res = await dispatch(Create(sendData));

      if (res.meta?.requestStatus === "fulfilled") {
        dispatch(GetAll());

        setModalsuccessShow(true); // SHOW SUCCESS MODAL

        reset(); // optional
        setShow(false); // close offcanvas
        setSuccess(true); // parent success flag (optional)
        setTimeout(() => {
          setModalsuccessShow(false);
        }, 3000);
      } else if (res.meta?.requestStatus === "rejected") {
        setShowError(res.payload?.response?.data?.errors);
        setShowRejectModal(true);
      }
    } catch (error) {
      setShow(false);
      setShowRejectModal(true);

      setErr(true);
      console.error(error);
    }
  };

  return (
    <>
      <Offcanvas
        show={show}
        onHide={handleClose}
        placement="end"
        className="view_application_canvas common_offcanvas"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Add</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="form_holder">
            <Form onSubmit={handleSubmit(onSubmit)}>
              <div className="row">
                <div className="col-md-4 mb-3">
                  <Form.Group className="form_field">
                    <Form.Label>Question</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Question"
                      className={classNames("", { "is-invalid": errors?.name })}
                      {...register("name", {
                        required: "Question is required",
                      })}
                    />
                    {errors?.name && (
                      <Form.Text className="text-danger">
                        {errors?.name?.message}
                      </Form.Text>
                    )}
                    {showError && (
                      <Form.Text className="text-danger">{showError}</Form.Text>
                    )}
                  </Form.Group>
                </div>
              </div>

              <div className="row">
                <div className="col-md-4 mb-3">
                  <Form.Group className="form_field">
                    <Form.Label>Answer</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Answer"
                      className={classNames("", { "is-invalid": errors?.name })}
                      {...register("description", {
                        required: "Answer is required",
                      })}
                    />
                    {errors?.description && (
                      <Form.Text className="text-danger">
                        {errors?.description?.message}
                      </Form.Text>
                    )}
                    {showError && (
                      <Form.Text className="text-danger">{showError}</Form.Text>
                    )}
                  </Form.Group>
                </div>
              </div>

              <div className="btn_holder">
                {/* <Blue_btn btn_text={"Cancle"} /> */}
                <Blue_border_button button_text={"Save"} type="submit" />
              </div>
            </Form>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <Success_modal
        show={modalSuccessShow}
        onHide={() => setModalsuccessShow(false)}
        message_text={"Operation was successful!"}
        animationData={successAnimation}
      />
    </>
  );
}

export default Add_offcanvas;
